import { TourPriceDto } from '@/features/dashboard/tourConfig/types/TourPriceDto.ts';

export const tourPriceDtoUtils = {
  getTourPriceDisplayString: (tourPrices: TourPriceDto[]): string => {
    // multiple currency support is not implemented yet

    // Pusty napis, a nie kreska: ten tekst trafia wyłącznie do eksportu XLSX,
    // gdzie pusta komórka jest pusta, a nie wygląda na błąd ładowania.
    if (tourPrices.length === 0) {
      return '';
    }

    if (tourPrices.length === 1) {
      const price = tourPrices[0].price;
      return `${price.amount}${price.currency}`;
    }

    const allPrices = tourPrices.map((tp) => tp.price.amount);
    const minPrice = Math.min(...allPrices);
    const maxPrice = Math.max(...allPrices);
    return `${minPrice} - ${maxPrice}${tourPrices[0].price.currency}`;
  },
};
